export default __webpack_public_path__ + "static/media/dom-res3.d89bc8b0.jpg";